module.exports = __webpack_public_path__ + "img/xld2.91d50eab.png";